import {en, es, ptBR} from 'vuejs-datepicker/dist/locale'
import CarInspectionHeaderForms from './form/carinspectionheader-form'
import CarInspectionHeaderModel from './model/carinspectionheadermodel'
import Tools from '@/components/tools/Tools.js'
import InsuranceMixin from '@/store/module/insurance/mixin.js'
import RegulationMixin from '@/store/module/regulation/mixin'

export default {
  name: 'SinisterHeader',
  mixins: [
    InsuranceMixin,
    RegulationMixin
  ],
  data () {
    return {
      data: CarInspectionHeaderModel,
      form: CarInspectionHeaderForms,
      en: en,
      es: es,
      ptBR: ptBR
    }
  },
  watch: {
    'regulation.id': function () {
      this.onEdit(this.regulation)
    }
  },
  methods: {
    onClear () {
      Tools.ClearDataForms(this.form, this.data)
    },
    onEdit (obj) {
      this.onClear()
      setTimeout(() => {
        this.fillData(obj)
      }, 1000)
    },
    fillData (obj) {
      if (this.hasRegulation) {
        this.form.plate.value = this.regulation.sinisterCode
        this.form.sinisterVersion.value = this.regulation.sinisterVersion
        this.form.insurance.value = this.regulation.insurance ? this.regulation.insurance.name : ''
        this.form.mechanicalWorkshop.value = this.regulation.mechanicalWorkshop ? this.regulation.mechanicalWorkshop.name : ''
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/regulation/auto/carinspectionheader/carinspectionheader.js